'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _biLoggerFactory = require('wix-bi-logger-client/dist/bi-logger-factory');

var _biLoggerFactory2 = _interopRequireDefault(_biLoggerFactory);

var _env = require('./lib/env');

var _publishers = require('./lib/publishers');

var _browsingSession = require('./browsingSession');

var browsingSession = _interopRequireWildcard(_browsingSession);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getPublisher() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var publisher = void 0;

  if ((0, _env.isWebWorker)()) {
    publisher = _publishers.fetchPublisher;
  } else if (options.useBeacon) {
    publisher = _publishers.beaconPublisher;
  } else {
    publisher = _publishers.imagePublisher;
  }

  return publisher(options);
}

var _factory = function _factory(options) {
  return new _biLoggerFactory2.default().addPublisher(getPublisher(options));
};

var logger = {
  factory: function factory(options) {
    browsingSession.track(_factory);
    return _factory(options);
  },
  setHost: _env.setHost
};

exports.default = logger;
//# sourceMappingURL=logger.js.map



//////////////////
// WEBPACK FOOTER
// ./~/web-bi-logger/dist/src/logger.js
// module id = 1126
// module chunks = 15 16 17 18 19